import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class ApplicationRoute extends Route {
  @service('intl') declare intl: any;

  beforeModel() {
    // Check for locale cookie and set it
    if (typeof document !== 'undefined') {
      const cookies = document.cookie.split(';');
      let locale = 'en'; // default

      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'locale') {
          locale = value || 'en';
          break;
        }
      }

      // Set locale (use 'es' for Spanish, ember-intl expects 'es')
      if (locale === 'es' || locale === 'es-AR') {
        this.intl.setLocale(['es']);
      } else {
        this.intl.setLocale(['en']);
      }
    }
  }
}

